import { PaginationResponse } from "../../Shared/Pagination/PaginationResponse";
import { deleteApi, getApi, getApiListById, postApi, postApiByPathParam, putApi } from "../../Shared/Services/RestService";
import { UserEarlyAccessResponse } from "../Types/EarlyAccessType";


export const getAllEarlyAccessData  = (page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApi<PaginationResponse<UserEarlyAccessResponse>>("/early-access", params);
};

export const createEarlyAccess = (payload: any) => {
  return postApi<UserEarlyAccessResponse>("/early-access", payload);
};


export const getAllEarlyAccessDataByRole  = (role:string, page: number =0 ,size?: number) => {
  const params: any = {
    page,
  };    
  // Only send size if provided
  if (size !== undefined) {
    params.size = size;
  }
  return getApiListById<PaginationResponse<UserEarlyAccessResponse>>("/early-access/role", role, params);
};


export const validateEarlyAccessUser = (userId: string) => {
  return getApi<UserEarlyAccessResponse>(`/early-access/${userId}`);
};

export const updateEarlyAccess = (id: string, payload: any) => {
  return putApi<UserEarlyAccessResponse>("/early-access", id, payload);
};

export const deleteEarlyAccess = (id: string) => {
  return deleteApi<UserEarlyAccessResponse>("/early-access", id);
};

export const sendLaunchEmailToEarlyAccess = (role?: string) => {
  const suffix = role ? `?role=${encodeURIComponent(role)}` : '';
  return postApiByPathParam<UserEarlyAccessResponse[]>(`/early-access/email${suffix}`);
};